import { create } from "zustand";

type DropdownStore = {
  dropdown: "";
  setDropdown: (dropdown: string) => void;
};

const dropdownStore = (set: any): DropdownStore => ({
  dropdown: "",
  setDropdown: (dropdown) => set({ dropdown }),
});

const useDropdownStore = create(dropdownStore);

export default useDropdownStore;
